/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_update_rejection_email_branding_rejection_email_rejectionemail_branding_put } from '../models/Body_update_rejection_email_branding_rejection_email_rejectionemail_branding_put';
import type { RejectionEmailCreateRequest } from '../models/RejectionEmailCreateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RejectionEmailService {

    /**
     * Create Rejection Email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createRejectionEmailRejectionEmailRejectionemailPost(
        requestBody: RejectionEmailCreateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/rejection-email/rejectionemail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Rejection Email Branding
     * @param opcoId
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateRejectionEmailBrandingRejectionEmailRejectionemailBrandingPut(
        opcoId: string,
        formData: Body_update_rejection_email_branding_rejection_email_rejectionemail_branding_put,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/rejection-email/rejectionemail/branding',
            query: {
                'opco_id': opcoId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Rejection Email Details
     * Get rejection email details (template, subject, branding, help portal URL, help email).
     * @param opcoId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRejectionEmailDetailsRejectionEmailRejectionemailOpcoIdGet(
        opcoId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rejection-email/rejectionemail/{opco_id}',
            path: {
                'opco_id': opcoId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Recipient Email
     * Get recipient email based on opco's rejectionemailtype.
     * Implements the logic from app.recipient_email() database function.
     * @param opcoId Operating company ID
     * @param supplierName Supplier name
     * @param emailId Email ID
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRecipientEmailRejectionEmailRecipientEmailGet(
        opcoId: number,
        supplierName?: (string | null),
        emailId?: (number | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rejection-email/recipient-email',
            query: {
                'opco_id': opcoId,
                'supplier_name': supplierName,
                'email_id': emailId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Invoice Details
     * Get invoice details (gl_date/invoice receive date).
     * Implements the logic from app.invoicedetails() database function.
     * @param invoiceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getInvoiceDetailsRejectionEmailInvoiceDetailsInvoiceIdGet(
        invoiceId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rejection-email/invoice-details/{invoice_id}',
            path: {
                'invoice_id': invoiceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
